const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export const currencyFormatter = {
  ...formatter,
  format: (value: number) => {
    const normalizedValue = value === 0 ? 0 : value;

    return formatter.format(normalizedValue);
  },
};
